import controller from './query-filters-modal.controller';
import template from './query-filters-modal.html';

export default ({ resolve }) => ({
	template,
	resolve,
	controller,
	controllerAs: '$ctrl',
});
